import { Button } from "antd";
import { Plus } from "lucide-react";
import { FC } from "react";
import { useClientStore } from "./clients.store";
import { ImportClientModal } from "./import-client-modal";

type Props = {};

export const HeaderClients: FC<Props> = () => {
  const { openClientModal } = useClientStore();

  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        <h1 className="text-2xl font-semibold">Client Management</h1>
        <p className="text-gray-500">
          Manage client information and relationships
        </p>
      </div>

      <div className="flex space-x-3">
        <ImportClientModal />
        <Button
          size="large"
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-sm flex items-center space-x-2"
          onClick={() => openClientModal()}
        >
          <Plus size={16} />
          <span>Add Client</span>
        </Button>
      </div>
    </div>
  );
};
